// extracted by mini-css-extract-plugin
export default {"skeletonRow":"PagoSkeleton_skeletonRow__mhzhi","skeletonCell":"PagoSkeleton_skeletonCell__BKPNB","loading":"PagoSkeleton_loading__3ZLNK"};